import utc from 'dayjs/plugin/utc';

import { DateUtil, ATTRIBUTE_TIME_SUFFIX } from '@adsk/docs-js-sdk';

const { DayJs } = DateUtil;

DayJs.extend(utc);

export const momentDiff = (
  dateStr1?: any,
  dateStr2?: any,
  type: DateUtil.DayJs.QUnitType | DateUtil.DayJs.OpUnitType = 'hours'
) => {
  if (!dateStr1 || !dateStr2) return Infinity;
  const converted1 = DayJs(dateStr1);
  const converted2 = DayJs(dateStr2);
  if (converted1.isValid() && converted2.isValid()) {
    return converted1.diff(converted2, type);
  }
  return Infinity;
};

export const daysDiff = (dateStr1?: any, dateStr2?: any) => {
  return momentDiff(dateStr1, dateStr2, 'days');
};

export const dateWithFixedTime = (
  date: any = '',
  useFixedTime: boolean = false,
  initialTime: string = ATTRIBUTE_TIME_SUFFIX
) => {
  if (!date) return null;

  const target = DayJs(date);
  if (!target.isValid()) return null;
  // Return ISO string if not with fixed time
  if (!useFixedTime) return target.utc().toISOString();
  // As WIP can only support UTC date time while CA only show date at UI by designed,
  // we use a fixed time to ensure the UTC date can show as expected after parsed to local timezone.
  return target.format(`YYYY-MM-DDT${initialTime}.000`) + 'Z';
};

export const dateToLocalString = (dateStr?: any) => {
  if (dateStr && DayJs(dateStr).isValid()) {
    return DayJs(dateStr).format('ll');
  }
  return null;
};

export const dateStringToMoment = (dateStr?: any) => {
  if (!dateStr) return null;
  if (DayJs.isDayjs(dateStr)) return dateStr.isValid() ? dateStr : null;

  const result = DayJs(dateStr);
  return result.isValid() ? result : null;
};
